module.exports = __webpack_public_path__ + "static/HelveticaNeue-Medium-5784082797c767efc7ecfa744c9fd6fb.otf";